import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { ServiceMarquee } from "@/components/site/ServiceMarquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Record } from "@/components/site/Record";
import { Boutique } from "@/components/site/Boutique";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { PaymentSuccess, PaymentCancel } from "@/components/site/PaymentResult";
import { LangProvider } from "@/i18n";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain" data-testid="app-root">
      <Nav />
      <main>
        <Hero />
        <ServiceMarquee />
        <Services />
        <About />
        <Record />
        <Boutique />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LangProvider>
      <Toaster position="bottom-right" theme="dark" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
